import React from "react";
import { Col, Pane, Row } from "@folio/stripes/components";
import { FormattedMessage, useIntl } from "react-intl";
import { RecekPaneSet } from "../../components/RecekPaneSet";
import NavComponent from "../../components/NavComponent";
import { ImportTypeList } from "../../components/import/ImportTypeList";
import { ImportForm } from "../../components/import/ImportForm";
import { TitleImportForm } from "../../components/import/TitleImportForm";
import { ThemaImportForm } from "../../components/import/ThemaImportForm";
import { useSelectedImport } from "../../hooks/useSelectedImport";
import { getImportTypeByKey } from "../../components/import/importTypesConfig";
var ImportPage = function () {
    var formatMessage = useIntl().formatMessage;
    var _a = useSelectedImport(), selectedImportKey = _a.selectedImportKey, setSelectedImport = _a.setSelectedImport;
    var selectedConfig = selectedImportKey
        ? getImportTypeByKey(selectedImportKey)
        : null;
    var renderImportContent = function () {
        if (!selectedImportKey || !selectedConfig) {
            return React.createElement(FormattedMessage, { id: "ui-br-agency.import.noSelectedType" });
        }
        if (selectedConfig.importFlow === "titleFile") {
            return React.createElement(TitleImportForm, null);
        }
        if (selectedConfig.importFlow === "thema") {
            return React.createElement(ThemaImportForm, null);
        }
        return React.createElement(ImportForm, { importTypeKey: selectedImportKey });
    };
    return (React.createElement(RecekPaneSet, null,
        React.createElement(Pane, { id: "menuPane", defaultWidth: "25%", paneTitle: formatMessage({
                id: "ui-br-agency.pane.title.navigation",
            }) },
            React.createElement(NavComponent, null)),
        React.createElement(Pane, { id: "contentPane", defaultWidth: "fill", paneTitle: React.createElement(FormattedMessage, { id: "ui-br-agency.import.title" }) },
            React.createElement(Row, null,
                React.createElement(Col, { xs: 12, md: 3 },
                    React.createElement(ImportTypeList, { selectedImport: selectedImportKey, onSelectImport: setSelectedImport })),
                React.createElement(Col, { xs: 12, mdOffset: 1, md: 8 }, renderImportContent())))));
};
export default ImportPage;
